// Footer info bar opening hours

document.addEventListener('DOMContentLoaded', function () {
	var openingHoursContent = document.querySelector('.footer-info-bar__content');
	var now = new Date();
	var day = now.getDay(); // Sunday - Saturday : 0 - 6
	var hour = now.getHours();
	var minute = now.getMinutes();

	// Adjust day index so that Monday is 0 and Sunday is 6
	day = (day + 6) % 7;

	var openTime = openingHoursContent.getAttribute('data-open-' + day);
	var closeTime = openingHoursContent.getAttribute('data-close-' + day);

	if (openTime && closeTime) {
		var openHour = parseInt(openTime.split(':')[0], 10);
		var openMinute = parseInt(openTime.split(':')[1], 10);
		var closeHour = parseInt(closeTime.split(':')[0], 10);
		var closeMinute = parseInt(closeTime.split(':')[1], 10);

		var isOpen = (hour > openHour || (hour === openHour && minute >= openMinute)) &&
			(hour < closeHour || (hour === closeHour && minute < closeMinute));

		if (isOpen) {
			openingHoursContent.innerHTML = `${translations.openMessage.replace('{(time)}', `${closeHour}:${closeMinute < 10 ? '0' + closeMinute : closeMinute}`)}`;
		} else {
			// Check if the shop opens later today
			if (hour < openHour || (hour === openHour && minute < openMinute)) {
				openingHoursContent.innerHTML = `${translations.closedMessage.replace('{(time)}', `${openHour}:${openMinute < 10 ? '0' + openMinute : openMinute}`).replace('{(day)}', '')}`;
			} else {
				// Find the next opening time
				var nextOpenDay = day;
				var nextOpenTime = null;
				for (var i = 1; i <= 7; i++) {
					nextOpenDay = (day + i) % 7;
					nextOpenTime = openingHoursContent.getAttribute('data-open-' + nextOpenDay);
					if (nextOpenTime) break;
				}

				var nextOpenHour = parseInt(nextOpenTime.split(':')[0], 10);
				var nextOpenMinute = parseInt(nextOpenTime.split(':')[1], 10);

				var nextOpenDayName = translations.onWeekdays[Object.keys(translations.onWeekdays)[nextOpenDay]];

				openingHoursContent.innerHTML = `${translations.closedMessage.replace('{(time)}', `${nextOpenHour}:${nextOpenMinute < 10 ? '0' + nextOpenMinute : nextOpenMinute}`).replace('{(day)}', nextOpenDayName)}`;
			}
		}
	} else {
		// Find the next opening time
		var nextOpenDay = day;
		var nextOpenTime = null;
		for (var i = 1; i <= 7; i++) {
			nextOpenDay = (day + i) % 7;
			nextOpenTime = openingHoursContent.getAttribute('data-open-' + nextOpenDay);
			if (nextOpenTime) break;
		}

		var nextOpenHour = parseInt(nextOpenTime.split(':')[0], 10);
		var nextOpenMinute = parseInt(nextOpenTime.split(':')[1], 10);

		var nextOpenDayName = translations.onWeekdays[Object.keys(translations.onWeekdays)[nextOpenDay]];

		openingHoursContent.innerHTML = `${translations.closedMessage.replace('{(time)}', `${nextOpenHour}:${nextOpenMinute < 10 ? '0' + nextOpenMinute : nextOpenMinute}`).replace('{(day)}', nextOpenDayName)}`;
	}
});